var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { initializeApp } from "firebase/app";
import { fetchAndActivate, getRemoteConfig, getValue, } from "firebase/remote-config";
import { setPollingUpdateFireBase, setisSolaceEnabled, setIsChartsIframeEnabled, setIsOderSetting, setIsPredefined, } from "src/redux/reducers/common-reducer";
import { store } from "src/redux/store";
import { FIRE_BASE_CONFIG, FIRE_BASE_POLLING } from "./constant";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "./session-storage";
import { captureCleverTabAnalytics } from "./analytics";
import { getBase64DecryptedAccessList } from "./methods";
import { setStockList, updateScripcodes } from "src/redux/reducers/modals";
const { REACT_APP_ENV } = process.env;
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: FIRE_BASE_CONFIG.apiKey,
    authDomain: FIRE_BASE_CONFIG.authDomain,
    databaseURL: FIRE_BASE_CONFIG.databaseURL,
    projectId: FIRE_BASE_CONFIG.projectId,
    storageBucket: FIRE_BASE_CONFIG.storageBucket,
    messagingSenderId: FIRE_BASE_CONFIG.messagingSenderId,
    appId: FIRE_BASE_CONFIG.appId,
    measurementId: FIRE_BASE_CONFIG.measurementId,
};
const defaultData = {
    derivative_clients_list: JSON.stringify({
        status: "ON",
        clientlist: [
            "57675310",
            "56294446",
            "50010738",
            "55515415",
            "58994144",
            "51439760",
            "54311569",
            "56226498",
            "53318809",
            "50604235",
            "50815291",
            "50223870",
            "54257493",
            "50725759",
        ],
        accesslist: "WyI1NzY3NTMxMCIsIjU2Mjk0NDQ2IiwiNTAwMTA3MzgiLCI1NTUxNTQxNSIsIjU4OTk0MTQ0IiwiNTE0Mzk3NjAiLCI1NDMxMTU2OSIsIjU2MjI2NDk4IiwiNTMzMTg4MDkiLCI1MDYwNDIzNSIsIjUwODE1MjkxIiwiNTAyMjM4NzAiLCI1NDI1NzQ5MyIsIjUwNzI1NzU5Il0=",
        disableExpiryCache: true,
        disableOptionsCache: true,
        disableOrderBookCache: false,
        disableChartsIframe: false,
    }),
    fno_polling_client_list: JSON.stringify({
        status: "ON",
        clientlist: [
            "50979417",
            "51018909",
            "50815291",
            "50223870",
            "50895759",
            "51692906",
        ],
        accesslist: "WyI1MDk3OTQxNyIsIjUxMDE4OTA5IiwiNTA4MTUyOTEiLCI1MDIyMzg3MCIsIjUwODk1NzU5IiwiNTE2OTI5MDYiXQ==",
        isPollingEnabled: "QA",
    }),
    fno_loggly_client_list: JSON.stringify({
        status: "ON",
        clientlist: [
            "57675310",
            "56294446",
            "50010738",
            "58994144",
            "51439760",
            "53318809",
            "50604235",
            "50223870",
            "54311569",
            "57803296",
            "58177885",
            "50645724",
            "57120786",
            "50815291",
            "51661291",
            "50979417",
            "52715111",
            "50725759",
            "51692906",
            "50761856",
        ],
        accesslist: "WyI1NzY3NTMxMCIsIjU2Mjk0NDQ2IiwiNTAwMTA3MzgiLCI1ODk5NDE0NCIsIjUxNDM5NzYwIiwiNTMzMTg4MDkiLCI1MDYwNDIzNSIsIjUwMjIzODcwIiwiNTQzMTE1NjkiLCI1NzgwMzI5NiIsIjU4MTc3ODg1IiwiNTA2NDU3MjQiLCI1NzEyMDc4NiIsIjUwODE1MjkxIiwiNTE2NjEyOTEiLCI1MDk3OTQxNyIsIjUyNzE1MTExIiwiNTA3MjU3NTkiLCI1MTY5MjkwNiIsIjUwNzYxODU2Il0=",
        logglyEnabled: "QA",
    }),
    fno_solace_client_list: JSON.stringify({
        status: "ON",
        clientlist: [
            "57675310",
            "56294446",
            "50010738",
            "58994144",
            "51439760",
            "53318809",
            "50604235",
            "50223870",
            "54311569",
            "57803296",
            "58177885",
            "50645724",
            "57120786",
            "50815291",
            "51661291",
            "50979417",
            "52715111",
            "50725759",
            "51692906",
            "50761856",
        ],
        accesslist: "WyI1NzY3NTMxMCIsIjU2Mjk0NDQ2IiwiNTAwMTA3MzgiLCI1ODk5NDE0NCIsIjUxNDM5NzYwIiwiNTMzMTg4MDkiLCI1MDYwNDIzNSIsIjUwMjIzODcwIiwiNTQzMTE1NjkiLCI1NzgwMzI5NiIsIjU4MTc3ODg1IiwiNTA2NDU3MjQiLCI1NzEyMDc4NiIsIjUwODE1MjkxIiwiNTE2NjEyOTEiLCI1MDk3OTQxNyIsIjUyNzE1MTExIiwiNTA3MjU3NTkiLCI1MTY5MjkwNiIsIjUwNzYxODU2Il0=",
        sandeshConfig: {
            config1: "U2FsdGVkX183G9mxEMVlGfNLwbs4M8IFvh3M1LRnj2E=",
            config2: "U2FsdGVkX183G9mxEMVlGfNLwbs4M8IFvh3M1LRnj2E=",
            isSolaceEnabled: "QA",
        },
    }),
    fno_chart_quantsapp_client_list: JSON.stringify({
        status: "ON",
        clientlist: ["51692906"],
        accesslist: "WyI1MTY5MjkwNiJd",
        isHideChartsIframe: true,
    }),
    fno_order_setting_predefined: JSON.stringify({
        status: "ON",
        clientlist: [
            "50725759",
            "51692906",
            "51692906",
            "51759479",
            "53076691",
            "52184770",
            "52131349",
            "52288141",
        ],
        accesslist: "WyI1MDcyNTc1OSIsIjUxNjkyOTA2IiwiNTE2OTI5MDYiLCI1MTc1OTQ3OSIsIjUzMDc2NjkxIiwiNTIxODQ3NzAiLCI1MjEzMTM0OSIsIjUyMjg4MTQxIl0=",
        isHideOrderSetting: "QA",
        isHidePredefined: "QA",
    }),
};
export const remoteConfigData = JSON.parse(defaultData.derivative_clients_list);
export let fetchAndActivatePromise;
export const initializeFireBaseAppAndRemoteConfig = () => {
    try {
        const app = initializeApp(firebaseConfig);
        const remoteConfig = getRemoteConfig(app);
        remoteConfig.settings.minimumFetchIntervalMillis = 60000;
        remoteConfig.defaultConfig = defaultData;
        refreshAndSetConfigData(remoteConfig);
        fetchAndActivate(remoteConfig)
            .then(() => {
            refreshAndSetConfigData(remoteConfig);
            getIndicesScripList(remoteConfig);
            getStockList(remoteConfig);
            // getLoginUrL(remoteConfig);
        })
            .catch((err) => {
            console.error(err, "error 1");
        });
    }
    catch (err) {
        console.error(err);
    }
};
// KEY FOR LOG MESSAGE IN LOGGLY AND CLEVARTAP
let logSolaceError = true;
const refreshAndSetConfigData = (remoteConfig) => {
    var _a;
    if (remoteConfig) {
        const stringValue = getValue(remoteConfig, "derivative_clients_list").asString();
        const solaceFireBaseConfig = getValue(remoteConfig, "fno_solace_client_list").asString();
        const orderSettingPredefined = getValue(remoteConfig, "fno_order_setting_predefined").asString();
        const pollingFireBaseConfig = getValue(remoteConfig, "fno_polling_client_list").asString();
        const logglyFireBaseConfig = getValue(remoteConfig, "fno_loggly_client_list").asString();
        const chartsQuantsappConfig = getValue(remoteConfig, "fno_chart_quantsapp_client_list").asString();
        try {
            // const remoteConfigData = JSON.parse(stringValue);
            const solaceFireBaseConfigData = JSON.parse(solaceFireBaseConfig);
            const pollingFireBaseConfigData = JSON.parse(pollingFireBaseConfig);
            const logglyFireBaseConfigData = JSON.parse(logglyFireBaseConfig);
            const chartsQuantsappConfigData = JSON.parse(chartsQuantsappConfig);
            const orderSettingPredefinedData = JSON.parse(orderSettingPredefined);
            // const frontendCrossSellConfigData = JSON.parse(frontend_crossSell_keys);
            const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
            const decryptedLogglyFireBaseAccesslist = getBase64DecryptedAccessList(logglyFireBaseConfigData === null || logglyFireBaseConfigData === void 0 ? void 0 : logglyFireBaseConfigData.accesslist);
            if (decryptedLogglyFireBaseAccesslist.includes(clientCode)) {
                setDataInSession(SESSION_KEYS.LOGGLY_CLIENT, true);
                // setDataInSession(SESSION_KEYS.ISSOLACE_ENABLED, true);
            }
            if (chartsQuantsappConfigData) {
                let checkIframeStatus = true;
                checkIframeStatus = (() => {
                    switch (chartsQuantsappConfigData === null || chartsQuantsappConfigData === void 0 ? void 0 : chartsQuantsappConfigData.isHideChartsIframe) {
                        case FIRE_BASE_POLLING.NO:
                            return true;
                        case FIRE_BASE_POLLING.YES:
                            return false;
                        case FIRE_BASE_POLLING.QA: {
                            const decryptedChartsQuantsappConfigDataAccesslist = getBase64DecryptedAccessList(chartsQuantsappConfigData === null || chartsQuantsappConfigData === void 0 ? void 0 : chartsQuantsappConfigData.accesslist);
                            if (decryptedChartsQuantsappConfigDataAccesslist.includes(clientCode)) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                        default: {
                            return true;
                        }
                    }
                })();
                store.dispatch(setIsChartsIframeEnabled(checkIframeStatus));
            }
            if (orderSettingPredefinedData) {
                try {
                    const isOrderSetting = checkOrderSetting(orderSettingPredefinedData, clientCode);
                    const isPredefined = checkPredefined(orderSettingPredefinedData, clientCode);
                    store.dispatch(setIsOderSetting(isOrderSetting));
                    store.dispatch(setIsPredefined(isPredefined));
                }
                catch (error) {
                    console.error(error);
                }
            }
            const checkSolace = getDataFromSession(SESSION_KEYS.SOLACE_ERROR) == true
                ? false
                : checkSolaceEnableFromFireBase(solaceFireBaseConfigData, clientCode);
            setDataInSession(SESSION_KEYS.SOLACE_ENABLED, checkSolace);
            const solaceTimer = (_a = solaceFireBaseConfigData === null || solaceFireBaseConfigData === void 0 ? void 0 : solaceFireBaseConfigData.sandeshConfig) === null || _a === void 0 ? void 0 : _a.solaceTimer;
            if (solaceTimer) {
                setDataInSession(SESSION_KEYS.SOLACE_TIMER, Number(solaceTimer));
            }
            else {
                setDataInSession(SESSION_KEYS.SOLACE_TIMER, 30);
            }
            store.dispatch(setisSolaceEnabled(checkSolace));
            if (!checkSolace && logSolaceError) {
                // checkAndLogMessage("SOLACE_CONNECTION_FAILED", {
                //   reason: "SOLACE_CONNECTION_FAILED",
                // });
                captureCleverTabAnalytics("SOLACE_CONNECTION_FAILED", {
                    clientCode: clientCode,
                    reason: "SOLACE_CONNECTION_FAILED",
                });
                logSolaceError = false;
            }
            const checkPolling = (() => {
                switch (pollingFireBaseConfigData === null || pollingFireBaseConfigData === void 0 ? void 0 : pollingFireBaseConfigData.isPollingEnabled) {
                    case FIRE_BASE_POLLING.NO:
                        return false;
                    case FIRE_BASE_POLLING.YES:
                        return true;
                    case FIRE_BASE_POLLING.QA: {
                        const decryptedPollingFireBaseAccesslist = getBase64DecryptedAccessList(pollingFireBaseConfigData === null || pollingFireBaseConfigData === void 0 ? void 0 : pollingFireBaseConfigData.accesslist);
                        if (decryptedPollingFireBaseAccesslist.includes(clientCode)) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }
                    default: {
                        return false;
                    }
                }
            })();
            if (pollingFireBaseConfigData) {
                store.dispatch(setPollingUpdateFireBase(checkPolling));
                setDataInSession(SESSION_KEYS.CHECK_FIREBASE_POLLING, checkPolling, true);
                // remoteConfigData.checkFireBasePolling = checkPolling;
            }
            else {
                setDataInSession(SESSION_KEYS.CHECK_FIREBASE_POLLING, true, true);
            }
        }
        catch (error) {
            if (typeof getDataFromSession(SESSION_KEYS.CHECK_FIREBASE_POLLING) ===
                "undefined") {
                setDataInSession(SESSION_KEYS.CHECK_FIREBASE_POLLING, true, true);
            }
            console.error(error, "erorr2");
        }
    }
};
const getIndicesScripList = (remoteConfig) => {
    try {
        if (remoteConfig) {
            const stringValue = getValue(remoteConfig, "fno_demo_indices_scripcodes").asString();
            let remoteConfigData = {};
            remoteConfigData = JSON.parse(stringValue);
            //console.log(JSON.parse(stringValue), "scriplist");
            if (remoteConfigData) {
                //console.log(remoteConfigData, "scriplist");
                store.dispatch(updateScripcodes(remoteConfigData));
            }
        }
    }
    catch (error) {
        console.error(error);
    }
};
const getStockList = (remoteConfig) => {
    try {
        if (remoteConfig) {
            const stringValue = getValue(remoteConfig, "fno_demo_stock_list").asString();
            let remoteConfigData = {};
            remoteConfigData = JSON.parse(stringValue);
            //console.log(JSON.parse(stringValue), "scriplist");
            if (remoteConfigData) {
                //console.log(remoteConfigData, "scriplist");
                store.dispatch(setStockList(remoteConfigData));
            }
        }
    }
    catch (error) {
        console.error(error);
    }
};
const checkSolaceEnableFromFireBase = (solaceFireBaseConfigData, clientCode) => {
    switch (solaceFireBaseConfigData === null || solaceFireBaseConfigData === void 0 ? void 0 : solaceFireBaseConfigData.sandeshConfig.isSolaceEnabled) {
        case FIRE_BASE_POLLING.NO:
            return false;
        case FIRE_BASE_POLLING.YES:
            return true;
        case FIRE_BASE_POLLING.QA: {
            const decryptedSolaceFireBaseAccesslist = getBase64DecryptedAccessList(solaceFireBaseConfigData === null || solaceFireBaseConfigData === void 0 ? void 0 : solaceFireBaseConfigData.accesslist);
            if (decryptedSolaceFireBaseAccesslist.includes(clientCode)) {
                return true;
            }
            else {
                return false;
            }
        }
        default: {
            return false;
        }
    }
};
function checkOrderSetting(orderSettingsPredefinedData, clientCode) {
    if (!orderSettingsPredefinedData) {
        throw new Error("orderSettingsPredefinedData is required");
    }
    switch (orderSettingsPredefinedData === null || orderSettingsPredefinedData === void 0 ? void 0 : orderSettingsPredefinedData.isHideOrderSetting) {
        case FIRE_BASE_POLLING.YES:
            return true;
        case FIRE_BASE_POLLING.QA: {
            const decryptedOrderSettingsPredefinedDataAccessList = getBase64DecryptedAccessList(orderSettingsPredefinedData === null || orderSettingsPredefinedData === void 0 ? void 0 : orderSettingsPredefinedData.accesslist);
            return decryptedOrderSettingsPredefinedDataAccessList.includes(clientCode);
        }
        case FIRE_BASE_POLLING.NO:
        default:
            return false;
    }
}
function checkPredefined(orderSettingsPredefinedData, clientCode) {
    if (!orderSettingsPredefinedData) {
        throw new Error("orderSettingsPredefinedData is required");
    }
    switch (orderSettingsPredefinedData === null || orderSettingsPredefinedData === void 0 ? void 0 : orderSettingsPredefinedData.isHidePredefined) {
        case FIRE_BASE_POLLING.YES:
            return true;
        case FIRE_BASE_POLLING.QA: {
            const decryptedorderSettingsPredefinedDataAccessList = getBase64DecryptedAccessList(orderSettingsPredefinedData === null || orderSettingsPredefinedData === void 0 ? void 0 : orderSettingsPredefinedData.accesslist);
            return decryptedorderSettingsPredefinedDataAccessList.includes(clientCode);
        }
        case FIRE_BASE_POLLING.NO:
        default:
            return false;
    }
}
export const getLoginUrL = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const app = initializeApp(firebaseConfig);
        const remoteConfig = getRemoteConfig(app);
        remoteConfig.settings.minimumFetchIntervalMillis = 60000;
        remoteConfig.defaultConfig = defaultData;
        yield fetchAndActivate(remoteConfig);
        // .then(() => {
        const stringValue = getValue(remoteConfig, "Login_Redirection_URL").asString();
        let remoteConfigData = {};
        remoteConfigData = JSON.parse(stringValue);
        // console.log(remoteConfigData, "remoteConfigData");
        setDataInSession(SESSION_KEYS.FIREBASE_LOGIN_URL, remoteConfigData.LoginRedirectionURL);
    }
    catch (error) {
        console.error("Error in initializing firebase", error);
    }
});
